import { Component, Inject } from '@angular/core';
import { NgbActiveModal, MODAL_DATA } from '@agilent/ui-element';

@Component({
    selector: 'auto-logout',
    templateUrl: './auto-logout.component.html',
    styleUrls: ['./auto-logout.component.scss']
})
export class AutoLogoutComponent {

    modalInfo: {
        countdown: number
    };

    constructor(
        private activeModal: NgbActiveModal,
        @Inject(MODAL_DATA) private modalData: any,
    ) {
        this.modalInfo = this.modalData.modalInfo;
    }

    onContinue() {
        this.activeModal.close({answer: 'Continue'});
    }

    onLogout() {
        this.activeModal.close({answer: 'Logout'});
    }
}
